import { render, staticRenderFns } from "./LeftDrawer.vue?vue&type=template&id=638fe8b7&"
import script from "./LeftDrawer.vue?vue&type=script&lang=js&"
export * from "./LeftDrawer.vue?vue&type=script&lang=js&"
import style0 from "./LeftDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VListItemIcon,VListItemTitle,VNavigationDrawer})
